import { Md5 } from "./md5";

export function joinGetParams(params: requestData): string {
    let data = '';
    for (let i in params) {
        data += `${i}=${params[i]}&`
    }
    return data.slice(0, data.length - 1);
}

//@ts-ignore
window.imgStorage = {}

export const SESSION_ID = 'session_id'

//todo 添加发行标识
export const getStorage = function (key: string) {
    try {
        return window.localStorage.getItem(key)
    } catch (e) {
        //@ts-ignore
        return window.imgStorage[key]
    }
}
//todo 添加发行标识
export const setStorage = function (key: string, data: any) {
    try {
        window.localStorage.setItem(key, data)
    } catch (e) {
        //@ts-ignore
        window.imgStorage[key] = data;
    }
}

export function jsonToQueryString(json: any, startWithQuestionMark: boolean = true) {
    const queryString = Object.keys(json).map(key => {
        return encodeURIComponent(key) + '=' + (json?.[key] ?? '');
    }).join('&');

    // 根据startWithQuestionMark决定是用?还是&开头
    return startWithQuestionMark ? '?' + queryString : '&' + queryString;
}

export function getOsVersion() {
    var u = navigator.userAgent, version = ''
    if (u.indexOf('Mac OS X') > -1) {
        // ios
        var regStr_saf = /OS [\d._]*/gi
        var verinfo = u.match(regStr_saf)
        version = 'IOS ' + (verinfo + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.')
    } else if (u.indexOf('Android') > -1 ||
        u.indexOf('Linux') > -1) {
        // android
        version = 'Android ' + u.substr(u.indexOf('Android') + 8, u.indexOf(';', u.indexOf('Android')) - u.indexOf('Android') - 8)
    } else if (u.indexOf('BB10') > -1) {
        // 黑莓bb10系统
        version = 'blackberry ' + u.substr(u.indexOf('BB10') + 5, u.indexOf(';', u.indexOf('BB10')) - u.indexOf('BB10') - 5)
    } else if (u.indexOf('IEMobile') > -1) {
        // windows phone
        version = 'winphone ' + u.substr(u.indexOf('IEMobile') + 9, u.indexOf(';', u.indexOf('IEMobile')) - u.indexOf('IEMobile') - 9)
    } else {
        var userAgent = navigator.userAgent.toLowerCase()
        if (userAgent.indexOf('windows nt 5.0') > -1) {
            version = 'Windows 2000'
        } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
            version = 'Windows XP'
        } else if (userAgent.indexOf('windows nt 6.0') > -1) {
            version = 'Windows Vista'
        } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
            version = 'Windows 7'
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
            version = 'Windows 8'
        } else if (userAgent.indexOf('windows nt 6.3') > -1) {
            version = 'Windows 8.1'
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
            version = 'Windows 10'
        } else {
            version = 'Unknown'
        }
    }
    return version.toLocaleLowerCase();
}

export function createH5SessionId(){
    let useragent = navigator.userAgent.toLocaleLowerCase();
    let sessionId = Md5.hashStr(useragent + (new Date().getTime() + Math.floor(Math.random() * 10000) / 10000));
    return sessionId
}

export function loadScript(url: string, callback?: () => any, errorBack?: (arg0: Error) => any, type?: string) {
    if (document.body) {
      let flag = false; // 是否已经执行过回调的标志位
      let script = document.createElement('script');
      const timeout = 2000;
      const timer = setTimeout(() => {
        if(!flag){
          flag =true;
          errorBack && errorBack(new Error(`Script load timeout for ${url}`));
        }
      }, timeout);
      script.src = url;
      script.onload = () => {
        if(!flag){
          flag = true;
          callback && callback();
          clearTimeout(timer);
        }
      };
      script.onerror = () => {
        if(!flag){
          flag = true;
          errorBack && errorBack(new Error(`Script load error for ${url}`));
          clearTimeout(timer);
        }
      };
      type && (script.type = type);
      document.body.append(script);
    } else {
      document.write(`<script src="${url}" onload="${callback}"><\/script>`)
    }
    // import(url).then(res=> { callback?.()})
    //   .catch(error => {
    //     errorBack?.()
    //   })
}

export const getAdPrams = () => {
    const query: any = new URLSearchParams(window.location.search);
    const ad = query.get('ad');
    let adParams: any = {}; 
    if (ad) {
        try {
            adParams = JSON.parse(window.atob(ad));
            console.log("adParams========>", adParams);
        } catch (error) {
            console.warn('格式化广告商参数报错')
        }
    }
    return adParams
}

export const getDeviceEnv = () => {
    const query: any = new URLSearchParams(window.location.search);
    const deviceEnv = query.get('deviceEnv');
    let params: any = {}; 
    if (deviceEnv) {
        try {
            params = JSON.parse(window.atob(deviceEnv));
            console.log("adParams========>", params);
        } catch (error) {
            console.warn('格式化广告商参数报错')
        }
    }
    return params
}

